import { get, callDelete, post, put } from "@/services/api.services";

export type ExperimentFile = {
    id: string;
    filename: string;
    arn: string;
    url: string;
    experimentCode: string;
    uploadedBy: string;
    visibility: string | null;
    category: string | null;
    createdAt: string;
    updatedAt: string;
};

export const filesAPI = {
    fetchExperimentFiles: async (experimentCode: string): Promise<ExperimentFile[]> => {
        return get(`/files/${experimentCode}`);
    },
    deleteExperimentFile: async (experimentCode: string, fileId: string) => {
        return callDelete(`/files/${experimentCode}/${fileId}`);
    },
    uploadExperimentFile: async (
        experimentCode: string,
        filename: string,
        uploadedBy: string,
        visibility: string | null,
        category: string | null
    ): Promise<ExperimentFile> => {
        return post(`/files/${experimentCode}`, {
            filename,
            uploadedBy,
            visibility,
            category,
        });
    },
    updateExperimentFile: async (
        experimentCode: string,
        fileId: string,
        category: string | null,
        visibility: string | null
    ): Promise<ExperimentFile> => {
        return put(`/files/${experimentCode}/${fileId}`, {
            category,
            visibility,
        });
    },
};
